import Split from '../../../../../split';

const hasRequiredRole = (user, roles = []) => {
    if (!roles.length) return true;

    const { role } = user;
    return roles.includes(role);
};

const isUserInactive = (user) =>
    String(user?.status ?? '')
        .trim()
        .toLowerCase() === 'inactive';

const hasRequiredPermissions = (user, item) => {
    if (item.hideIfInactive && isUserInactive(user)) return false;

    if (!item.permission?.length) return true;

    const shouldCheck = item.subPermissionOnly ? user.subuser : true;
    if (!shouldCheck) return true;

    const userPerms = user?.permissions || [];
    const requiresAll = item.requireAllPermissions !== false;

    return requiresAll
        ? item.permission.every((perm) => userPerms.includes(perm)) // wrap
        : item.permission.some((perm) => userPerms.includes(perm));
};

const hasSplitTreatment = (item, user) => {
    if (!item.split) return true;

    const attributes = Split.getAttributes();
    if (Object.keys(attributes).length === 0) {
        Split.setAttributes(user);
    }

    return Split.getBooleanTreatment(item.split) === true;
};

export const canAccessItem = (user, item) => {
    if (item.type === 'group' && item.children?.length) {
        const visibleChildren = item.children.filter(
            (child) =>
                hasRequiredRole(user, child.roles) &&
                hasRequiredPermissions(user, {
                    ...child,
                    subPermissionOnly: child.subPermissionOnly ?? item.subPermissionOnly ?? false,
                }) &&
                hasSplitTreatment(child, user)
        );

        const requireAll = item.requireAllPermissions !== false;
        return requireAll ? visibleChildren.length === item.children.length : visibleChildren.length > 0;
    }

    return (
        hasRequiredRole(user, item.roles) &&
        hasRequiredPermissions(user, item) && // wrap
        hasSplitTreatment(item, user)
    );
};

export const groupVisibleChildrenByHeader = (children, user) => {
    const groups = children.reduce((acc, item) => {
        if (item.type === 'subheader') {
            acc.push({ header: item.title, items: [] });
        } else if (canAccessItem(user, item)) {
            if (!acc.length) {
                acc.push({ header: null, items: [] });
            }
            acc[acc.length - 1].items.push(item);
        }
        return acc;
    }, []);

    return groups.filter((g) => g.items.length > 0);
};

export const getBookmarksConfig = (bookmarks, config, user) => {
    return bookmarks.length
        ? {
              id: 'bookmarks-group',
              title: 'Bookmarks',
              icon: 'Bookmarks',
              type: 'group',
              children: bookmarks
                  .map((id) =>
                      config
                          .flatMap((item) => (item.type === 'group' ? item.children || [] : item)) // wrap
                          .find((child) => child.id === id)
                  )
                  .filter((item) => item && canAccessItem(user, item)),
          }
        : null;
};
